module.exports = __webpack_public_path__ + "static/media/private-group.4aeedaec.svg";